// extracted by mini-css-extract-plugin
module.exports = {"container":"TextInput_container__XKXqT"};